/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Workspace } from './Workspace';
import {
    WorkspaceFromJSON,
    WorkspaceFromJSONTyped,
    WorkspaceToJSON,
    WorkspaceToJSONTyped,
} from './Workspace';

/**
 * 
 * @export
 * @interface DeleteWorkspaceResponse
 */
export interface DeleteWorkspaceResponse {
    /**
     * Whether the deletion was successful
     * @type {boolean}
     * @memberof DeleteWorkspaceResponse
     */
    success: boolean;
    /**
     * The deleted workspace
     * @type {Workspace}
     * @memberof DeleteWorkspaceResponse
     */
    workspace: Workspace;
}

/**
 * Check if a given object implements the DeleteWorkspaceResponse interface.
 */
export function instanceOfDeleteWorkspaceResponse(value: object): value is DeleteWorkspaceResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('workspace' in value) || value['workspace'] === undefined) return false;
    return true;
}

export function DeleteWorkspaceResponseFromJSON(json: any): DeleteWorkspaceResponse {
    return DeleteWorkspaceResponseFromJSONTyped(json, false);
}

export function DeleteWorkspaceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteWorkspaceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'workspace': WorkspaceFromJSON(json['workspace']),
    };
}

export function DeleteWorkspaceResponseToJSON(json: any): DeleteWorkspaceResponse {
    return DeleteWorkspaceResponseToJSONTyped(json, false);
}

export function DeleteWorkspaceResponseToJSONTyped(value?: DeleteWorkspaceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'workspace': WorkspaceToJSON(value['workspace']),
    };
}

